// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Provides helper methods for type checking.
 */
export class TypeUtility
{
  static isArray(value: any): value is any[]
  {
    return value && typeof value === "object" && value.constructor === Array;
  }

  static isBoolean(value: any): value is boolean
  {
    return typeof value === "boolean";
  }

  static isDate(value: any): value is Date
  {
    return value instanceof Date;
  }

  static isError(value: any): value is Error
  {
    return value instanceof Error && typeof value.message !== "undefined";
  }

  static isInteger(value: any): value is number
  {
    return typeof value === "number" && Number.isInteger(value);
  }

  static isFunction(value: any): value is (...args: any[]) => any
  {
    return typeof value === "function";
  }

  static isNull(value: any): value is null
  {
    return value === null;
  }

  static isNumber(value: any): value is number
  {
    return typeof value === "number" && isFinite(value);
  }

  static isObject(value: any): value is object
  {
    return value && typeof value === "object";// && value.constructor === Object;
  }

  static isRegExp(value: any): value is RegExp
  {
    return value && typeof value === "object" && value.constructor === RegExp;
  }

  static isPromise(value: any): value is Promise<any>
  {
    return value && typeof value === "object" && typeof value["then"] === "function";
  }

  static isString(value: any): value is string
  {
    return typeof value === "string" || value instanceof String;
  }

  static isUndefined(value: any): value is undefined
  {
    return typeof value === "undefined";
  }
}